export const copyToClipboard = (text: string, successCallback: () => void): void => {
    navigator.clipboard.writeText(text).then(successCallback, err => {
        // eslint-disable-next-line no-console
        console.error('Não foi possível copiar o texto: ', err);
    });
};
